import { RECEIVED_SEARCH_RESULTS } from "../constants/searchConstants";

export const receivedSearchResults = (initiator, searchResults) => ({
  type: RECEIVED_SEARCH_RESULTS,
  initiator,
  searchResults,
});
